var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"group":"notifications","position":"bottom right","classes":"custom-notify-style"}})
}
var staticRenderFns = []

export { render, staticRenderFns }